import { getCrmMaintenanceUrl } from '@/utils/crm/crmUrls';
import { isAllowedCrmRedirect } from '@/utils/crm/isAllowedCrmRedirect';
import { isAlreadyOnMaintenancePage } from '@/utils/maintenance/isAlreadyOnMaintenancePage';

let isRedirectingToMaintenance = false;

function resolveMaintenanceUrl(url?: string): string | null {
  const trimmed = url?.trim();
  if (trimmed && isAllowedCrmRedirect(trimmed)) {
    return trimmed;
  }

  const maintenanceUrl = getCrmMaintenanceUrl();
  if (isAllowedCrmRedirect(maintenanceUrl)) {
    return maintenanceUrl;
  }

  return null;
}

export function redirectToMaintenancePage(url?: string): void {
  if (typeof window === 'undefined') {
    return;
  }

  if (isRedirectingToMaintenance || isAlreadyOnMaintenancePage()) {
    return;
  }

  const targetUrl = resolveMaintenanceUrl(url);
  if (!targetUrl) {
    return;
  }

  isRedirectingToMaintenance = true;
  window.location.href = targetUrl;
}
